import React, { useEffect, useState } from 'react';

import { makeStyles, Tooltip } from '../library';
import {
    InputAdornment,
    TextField,
    Typography,
    Autocomplete,
    Chip,
    MenuItem
} from '../library';

import { SearchAcumulativeIcon, SearchIcon, SearchNotIcon } from '../icons';

import * as icons from '../icons';
import * as helpers from '../helpers';

const useStyles = makeStyles(theme => ({
    root: {},
    wrapper: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'flex-star',
        alignItems: 'center',
        '& > *': {
            marginRight: theme.spacing(1)
        }
    }
}));

const getNewFlag = flag => {
    if (flag === '!') return '===';
    if (flag === '===') return '=';

    return '!';
};

const getIconFlag = flag => {
    const size = 20;

    if (flag === '!')
        return <SearchNotIcon sx={{ fontSize: size, color: 'darkred' }} />;

    if (flag === '===')
        return (
            <SearchAcumulativeIcon sx={{ fontSize: size, color: 'darkblue' }} />
        );

    return <SearchIcon sx={{ fontSize: size }} />;
};

const getTextFlag = flag => {
    if (flag === '!') return 'Valores que NO INCLUYAN';

    if (flag === '===') return 'Valores que CUMPLAN ESTRICTAMENTE';

    return 'Valores que INCLUYAN';
};

const FilterSelector = props => {
    const {
        title,
        value,
        options,
        multiple,
        modificador,
        type,
        onFilter,
        onChange,
        onClick,
        disabled
    } = props;
    const classes = useStyles();

    const [flag, setFlag] = useState(modificador);

    useEffect(() => {
        if (value) {
            filtra(value);
        }
    }, [JSON.stringify(value)]);

    useEffect(() => {
        if (value) {
            filtra(value);
        }
    }, [flag]);

    const getOption = value => {
        if (Array.isArray(value)) {
            let newArray = [];
            value.forEach(v => {
                newArray.push(getOption(v));
            });

            return newArray;
        }

        return options.find(option => option.value === value);
    };

    const getValue = option => {
        if (Array.isArray(option)) {
            let newArray = [];
            option.forEach(o => {
                newArray.push(getValue(o));
            });

            return newArray;
        }

        const newValue = option ? option.value : null;

        return newValue;
    };

    const filtra = value => {
        onChange && onChange(value);
        let newValue = null;

        if (Array.isArray(value))
            value.length === 0 ? (newValue = '') : (newValue = value);
        else !value ? (newValue = '') : (newValue = value);

        helpers.timeBox(() => onFilter && onFilter(newValue, flag), 300);
    };

    return (
        <Autocomplete
            filterSelectedOptions
            defaultValue={getOption(value)}
            style={{ minWidth: 200 }}
            multiple={multiple}
            onChange={(event, data) => filtra(getValue(data))}
            options={options}
            getOptionLabel={option => option.label}
            clearText='Borrar'
            closeText='Cerrar'
            openText='Abrir'
            noOptionsText={'No encontrado'}
            renderInput={props => (
                <TextField
                    {...props}
                    fullWidth
                    label={title}
                    variant='standard'
                    size='small'
                    margin='none'
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                        ...props.InputProps,
                        startAdornment: (
                            <React.Fragment>
                                <InputAdornment
                                    sx={{
                                        cursor:
                                            onClick && modificador
                                                ? 'pointer'
                                                : 'default'
                                    }}
                                    position='start'
                                    onClick={
                                        onClick &&
                                        modificador &&
                                        (() => {
                                            const newFlag = getNewFlag(flag);
                                            setFlag(newFlag);
                                            onClick(newFlag);
                                        })
                                    }
                                >
                                    {modificador ? (
                                        <Tooltip title={getTextFlag(flag)}>
                                            {getIconFlag(flag)}
                                        </Tooltip>
                                    ) : (
                                        <SearchIcon sx={{ fontSize: 20 }} />
                                    )}
                                </InputAdornment>
                                {props.InputProps.startAdornment}
                            </React.Fragment>
                        ),
                        endAdornment: (
                            <React.Fragment>
                                {props.InputProps.endAdornment}
                            </React.Fragment>
                        )
                    }}
                />
            )}
            renderOption={(props, option, { selected }) => (
                <MenuItem {...props} value={option.value}>
                    <div
                        className={classes.wrapper}
                        style={{ color: option.color }}
                    >
                        {selected && (
                            <icons.SelectedIcon
                                sx={{
                                    fontSize: 18,
                                    color: 'black'
                                }}
                            />
                        )}
                        {option.icon && <option.icon fontSize='small' />}
                        <Typography color='inherit' variant='h6'>
                            {option.label}
                        </Typography>
                    </div>
                </MenuItem>
            )}
            renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                    <Chip
                        style={{
                            color: option.color,
                            borderColor: option.color
                        }}
                        variant='outlined'
                        size='small'
                        icon={option.icon && <option.icon />}
                        label={option.label}
                        {...getTagProps({ index })}
                    />
                ))
            }
        />
    );
};

export default FilterSelector;
